import { __rest } from "tslib";
import React from 'react';
import { Button, Title, YFMWrapper } from '../../components';
import LinkBlock from '../../components/Link/Link';
import { Col } from '../../grid';
import { block } from '../../utils';
import './Content.css';
const b = block('content');
function getTextSize(size) {
    switch (size) {
        case 's':
            return 's';
        case 'l':
        default:
            return 'm';
    }
}
function getLinkSize(size) {
    switch (size) {
        case 's':
            return 'm';
        case 'l':
        default:
            return 'l';
    }
}
function getButtonSize(size) {
    switch (size) {
        case 's':
            return 'm';
        case 'l':
        default:
            return 'xl';
    }
}
const Content = (props) => {
    const { title, text, additionalInfo, size = 'l', links, buttons, colSizes = { all: 12, sm: 8 }, centered, theme, className, } = props;
    const titleProps = __rest(!title || typeof title === 'string'
        ? { text: title, textSize: getTextSize(size) }
        : title, []);
    const hasTitle = Boolean(title);
    return (React.createElement(Col, { className: b({ size, centered, theme }, className), reset: true, sizes: colSizes },
        title && React.createElement(Title, Object.assign({ className: b('title') }, titleProps, { resetMargin: true })),
        text && (React.createElement("div", { className: b('text', { ['without-title']: !hasTitle }) },
            React.createElement(YFMWrapper, { content: text, modifiers: { constructor: true, [`constructor-size-${size}`]: true } }))),
        additionalInfo && (React.createElement("div", { className: b('notice') },
            React.createElement(YFMWrapper, { content: additionalInfo, modifiers: {
                    constructor: true,
                    'constructor-notice': true,
                    [`constructor-size-${size}`]: true,
                } }))),
        links && (React.createElement("div", { className: b('links') }, links.map((link) => (React.createElement(LinkBlock, Object.assign({ className: b('link') }, link, { textSize: getLinkSize(size), key: link.url })))))),
        buttons && (React.createElement("div", { className: b('buttons') }, buttons.map((item) => (React.createElement(Button, Object.assign({ className: b('button') }, item, { key: item.url, size: getButtonSize(size) }))))))));
};
export default Content;
